import { useState } from 'react';
import { vevet } from '@anton.bobrov/vevet-init';
import { useOnResize } from './useOnResize';
/** Use `vevet` `Viewport` size */
export function useViewportSize() {
    var _a = useState({
        width: 0,
        height: 0,
    }), size = _a[0], setSize = _a[1];
    useOnResize(function () {
        return setSize({
            width: vevet.viewport.width,
            height: vevet.viewport.height,
        });
    }, []);
    return size;
}
//# sourceMappingURL=useViewportSize.js.map